import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, Transition } from '@headlessui/react';
import PropTypes from 'prop-types';
import { Fragment, memo } from 'react';
const ModalWrapper = ({ children, isOpened, width, onCloseModal }) => {
    return (_jsx(Transition.Root, { show: Boolean(isOpened), as: Fragment, children: _jsxs(Dialog, { static: true, open: isOpened, onClose: onCloseModal, className: "fixed inset-0 min-h-screen overflow-y-auto grid z-[2000]", children: [_jsx(Transition.Child, { as: Fragment, enter: "ease-out duration-300", enterFrom: "opacity-0", enterTo: "opacity-100", leave: "ease-in duration-200", leaveFrom: "opacity-100", leaveTo: "opacity-0", children: _jsx("div", { className: "fixed inset-0 transition-opacity bg-gray-600 bg-opacity-25" }) }), _jsx("div", { className: `self-center justify-self-center p-2 ${width ?? ''}`, children: _jsxs(Dialog.Panel, { className: "rounded-lg bg-white shadow-xl relative", children: [_jsx("div", { tabIndex: 0, "aria-hidden": true }), children] }) })] }) }));
};
ModalWrapper.propTypes = {
    width: PropTypes.string,
    children: PropTypes.node,
    isOpened: PropTypes.bool,
    onCloseModal: PropTypes.func,
};
export default memo(ModalWrapper);
